import {
  Box,
  Button,
  Heading,
  Text,
  VStack,
  Image,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
} from "@chakra-ui/react";
const BookingSection = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <Box bg="white" py={16} textAlign="center">
      <VStack spacing={4} maxW="xl" mx="auto">
        <Box as="span" display="block" fontSize="40px">
          <Image
            src="/logo.svg"
            alt="Qualiteeth Dental Care"
            loading="lazy"
            height="50px"
            filter="grayscale(1) brightness(0)"
          />
        </Box>
        <Heading
          fontSize={{ base: "2xl", md: "5xl" }}
          fontWeight="light"
          mb={4}
        >
          Book today for quality care
        </Heading>
        <Text fontSize="lg" color="black" fontWeight="light" mb={4}>
          Qualiteeth Dental is committed to exceptional care with cutting-edge
          technology and an experienced team that prioritizes your well-being.
        </Text>
        <Button
          name="Book Online"
          bg="#28211d"
          color="#fceee5"
          _hover={{ color: "#c49d84"}}
          onClick={onOpen}
        >
          BOOK ONLINE
        </Button>
        <Modal
          isOpen={isOpen}
          onClose={onClose}
          size="xl"
          blockScrollOnMount={true}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalCloseButton />
            <ModalBody>
              <iframe
                title="Book an appointment at Qualiteeth Dental Care"
                  src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ0HH7UcCwpUcb-NlDA38ZGn_NmQqHUJ9llAjBKixKAX-8BT0MCXFwBnZaMcnlb3-6fw9BMPDcs2?gv=true"
                style={{ border: "0", width: "100%", height: "600px" }}
                frameBorder="0"
              ></iframe>
            </ModalBody>
          </ModalContent>
        </Modal>
      </VStack>
    </Box>
  );
};

export default BookingSection;
